import type {ReactElement} from 'react';
import React from 'react';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {numberToMMSSFormat} from '@Utils/date.util';
import styles from './stop-video-recording-button.module.scss';

interface StopVideoRecordingButtonProps {
  isOnMobile?: boolean;
  duration: number;
  stopRecordingVideo(): void;
}

export function StopVideoRecordingButton({isOnMobile = false, ...props}: StopVideoRecordingButtonProps): ReactElement | null {
  return (
    <div className="flex-row-justify-between flex-items-center">
      <div className="flex-h-row flex-row-justify-between flex-items-center">
        <div className={`${styles.wrapper} ${!isOnMobile ? styles.marginOnDesktop : styles.wrapperMobile} radius-round flex-center`}>
          <ClickableDiv
            onClick={(): void => {
              props.stopRecordingVideo();
            }}
            className={`${styles.button} hover-transition-all flex-center`}
          >
            <Icon icon="icon-stop-video" size={IconSize.SIZE_ICON_32} />
          </ClickableDiv>
        </div>
        <Text className={`spacing-m-l-4 ${styles.durationText}`} val={numberToMMSSFormat(props.duration)} bold size={TextSize.SMALL} />
      </div>
    </div>
  );
}
